<app-layout>
  <header>
    <h2>
      <i class="pi pi-chart-bar"></i> Reportes y estadísticas
    </h2>

    <form [formGroup]="reportsForm" novalidate (submit)="onSubmit($event)" class="form">
      <figcaption class="form-figcaption">
        Puedes filtrar los reportes por fecha
      </figcaption>

      <div class="form-group">
        <p-calendar formControlName="initial_date" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
          placeholder="Fecha de inicio" />

        <p-calendar formControlName="final_date" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
          placeholder="Fecha de final" />

        <button type="submit" class="button">
          Filtrar reportes
        </button>

        <span pTooltip="Selecciona un un rango de fechas para exportar el PDF" tooltipPosition="top"
          class="tooltip-wrapper">
          <p-button type="button" icon="pi pi-file-pdf" class="p-button-danger" label="Exportar PDF"
            [disabled]="!canExportPdf" (click)="exportPdfBackend()"></p-button>
        </span>
      </div>
    </form>
  </header>

  @for (client of clients; track client.id) {
    <article class="report-container">
      <h4 class="report-title">
        Reportes para {{ client.name }}
      </h4>

      <app-customer-report [clientId]="client.id" [initialDate]="initialDate"
        [finalDate]="finalDate"></app-customer-report>
    </article>
  }
</app-layout>
